export default function fetchWithTimeout(url: RequestInfo, options: RequestInit, ms: number = 60000) {
  const controller = new AbortController();
  const promise = fetch(url, { ...options, signal: controller.signal });
  const timeout = setTimeout(() => controller.abort(), ms);

  return promise.finally(() => clearTimeout(timeout));
}
